var React = require('react');

function StayNimbleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.6 40c20.85-7.97 31.26-23.2 31.26-23.2l7.9 1.3L29.96.74 9.12 12.93l9.12 1.3c1.97 4.88-4.4 17-15.64 25.78z","fill":"#ffb84a","key":0}),React.createElement("path",{"d":"M14.57 37.56C30.8 36.9 43 33.67 43 33.67l4.03 3.72-.5-14.14-13.08-2.12 2.73 3.77c-3.7 5.47-11.9 9.9-21.63 12.66z","fill":"#5f4596","key":1})]);
}

StayNimbleMobile.defaultProps = {"width":"48","height":"41","fill":"none","fillRule":"evenodd"};

module.exports = StayNimbleMobile;

StayNimbleMobile.default = StayNimbleMobile;
